// import arabic from './arabic' // uncomment this to enable arabic option in the language selector dropdown
// const data = Object.assign({}, arabic) // uncomment this to enable arabic option in the language selector dropdown

const data = {};

export default data;
